<!-- Text displayed in forms, considered a field -->
<div class="page-text">
  <span [innerHTML]="field.label"></span>
</div>